import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import logo from "../../assets/images/logo.png";
import bgImage from '../../assets/images/bg.jpeg';
import "../../styles/auth.css";

const ForgotPassword = () => {
    //const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);
    const [successResponse, setSuccessResponse] = useState(false);


    const [isOtp, setIsOtp] = useState(false);
    const [passEye, setPassEye] = useState(false);
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const passwordRegrx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;


    const [inputData, setInputData] = useState({
        email: "",
        otp: "",
        new_password: '',
        confirm_new_password: ''
    });

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(false);
        setSuccessResponse(false);


        const { email } = inputData;
        if (!email) {
            setInputError(true);
            setIsBtn(false)
        } else {

            setInputError(false);

            await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/forgot-password", {
                email: email,
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        //Swal.fire({ icon: "success", title: "Email Sent", text: "Please check your emails for a message with your reset password code." });
                        setSuccessResponse("We have sent you an email with authentication code. Please enter this code along with your new password. ");
                        setInputData({ ...inputData, email: email, role: response?.data?.role })
                        setIsOtp(true);

                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Login Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setIsBtn(true);
        setErrorResponse(false);
        setSuccessResponse(false);
        setInputError(false);


        const { email, otp, new_password, confirm_new_password, role } = inputData;
        if (!email || !otp || !new_password || new_password !== confirm_new_password || !new_password.match(passwordRegrx)) {
            setInputError(true);
            setIsBtn(false)

        } else {

            await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/reset-password", {
                email: email,
                otp: otp,
                role: role,
                new_password: new_password,
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        //Swal.fire({ icon: "success", title: "Email Sent", text: "Please check your emails for a message with your reset password code." });
                        setSuccessResponse(<span>Password updated successfully! <a href='/login'>Click here</a> to login.</span>);
                        setInputData({
                            email: "",
                            otp: "",
                            new_password: '',
                            confirm_new_password: ''
                        })
                        setIsOtp(false);

                    } else {

                        setErrorResponse(response?.data?.message);
                        //Swal.fire({ icon: "error", title: "Login Failed", text: response?.data?.message, footer: '<a href="/forgot-password">Forgot Password</a>' });

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Login Failed", text: error.message });

                });

        }
    };

    return (


        <div className="login-page bg-light" style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }} >
            <div className="login-box">
                <div className="card card-outline card-primary bg-white-partial">
                    <div className="card-header text-center">
                        <a href="#" className="link-dark text-center">
                            <img src={logo} alt="Logo" />
                        </a>

                    </div>
                    <div className="card-body login-card-body bg-transparent">
                        <>

                            {errorResponse &&
                                <div className="alert alert-danger" role="alert">
                                    {errorResponse}
                                </div>
                            }
                            {successResponse &&
                                <div className="alert alert-success" role="alert">
                                    {successResponse}
                                </div>
                            }


                            {isOtp === false ?
                                <form onSubmit={(e) => handleForgotPassword(e)}>

                                    <p className="login-box-msg">Forgot Password</p>

                                    <div className="input-group mb-1">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" placeholder="" name="email" id="email"
                                                value={inputData.email} onChange={(e) => setInputData({ ...inputData, email: e.target.value })}
                                            />
                                            <label for="loginEmail">Email</label>
                                            {inputError &&
                                                (!inputData.email ||
                                                    !emailRegex.test(inputData.email)) && (
                                                    <span className="text-danger">
                                                        {inputData.email && !emailRegex.test(inputData.email)
                                                            ? "Invalid email address"
                                                            : "This field is required"}
                                                    </span>
                                                )}
                                        </div>
                                        <div className="input-group-text"><span className="bi bi-envelope"></span></div>
                                    </div>



                                    <div className="row py-2">
                                        <div className="col-6 d-inline-flex align-items-center">
                                            <Link className="btn btn-link text-primary px-0 " to="/login">Login Page</Link>
                                        </div>
                                        <div className="col-6 ">

                                            <div className="d-grid gap-2">
                                                <button type="submit" className="btn btn-primary" disabled={isBtn}>
                                                    {isBtn ? <Loading /> : 'Reset Password '}
                                                </button>
                                            </div>
                                        </div >


                                    </div>
                                </form>
                                :
                                <form onSubmit={(e) => handleResetPassword(e)}>
                                    <p className="login-box-msg">Enter Your New Password</p>



                                    <div className="input-group mb-1">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="" name="otp" id="otp"
                                                value={inputData.otp} onChange={(e) => setInputData({ ...inputData, otp: e.target.value })}
                                            />
                                            <label for="loginOtp">Enter code sent on your email</label>
                                            {inputError && !inputData.otp && (
                                                <span className="text-danger">
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                        <div className="input-group-text"><span className="bi bi-key"></span></div>
                                    </div>


                                    <div className="input-group mb-1">
                                        <div className="form-floating">
                                            <input type={`${!passEye ? `password` : `text`}`} className="form-control " id="new_password"
                                                name="new_password" value={inputData.new_password}
                                                onChange={(e) =>
                                                    setInputData({ ...inputData, new_password: e.target.value })
                                                } />


                                            <label for="loginPassword">New Password: *</label>

                                            {inputError && !inputData.new_password && (
                                                <span className="text-danger">This field is required</span>
                                            )}
                                            {inputError && !inputData?.new_password?.match(passwordRegrx) && (
                                                <span className="text-danger">Password must be minimum eight characters long and have at least one uppercase letter, one lowercase letter, one number and one special character.</span>
                                            )}

                                        </div>
                                        <div className="input-group-text">
                                            {(passEye) ?
                                                <span className="bi bi-eye" onClick={() => setPassEye(!passEye)} ></span>
                                                :
                                                <span className="bi bi-eye-fill" onClick={() => setPassEye(!passEye)}  ></span>
                                            }
                                        </div>
                                    </div>




                                    <div className="input-group mb-1">
                                        <div className="form-floating">
                                            <input type={`${!passEye ? `password` : `text`}`} className="form-control" id="confirm_new_password"
                                                name="confirm_new_password" value={inputData.confirm_new_password}
                                                onChange={(e) =>
                                                    setInputData({ ...inputData, confirm_new_password: e.target.value })
                                                } />


                                            <label for="loginPassword">Confirm Password: *</label>

                                            {inputData.new_password && inputError && (!inputData.confirm_new_password || inputData.new_password !== inputData.confirm_new_password) && (
                                                <span className="text-danger">
                                                    {inputData.confirm_new_password && inputData.new_password !== inputData.confirm_new_password
                                                        ? "Your password and confirmation password do not match"
                                                        : "This field is required"}
                                                </span>
                                            )}


                                        </div>
                                        <div className="input-group-text">
                                            {(passEye) ?
                                                <span className="bi bi-eye" onClick={() => setPassEye(!passEye)} ></span>
                                                :
                                                <span className="bi bi-eye-fill" onClick={() => setPassEye(!passEye)}  ></span>
                                            }
                                        </div>
                                    </div>







                                    <div className="row py-2">



                                        <div className="col-5 d-inline-flex align-items-center">

                                            <Link className="btn btn-link text-primary px-0 " to="/login">Login Page</Link>

                                        </div>

                                        <div className="col-7 ">

                                            <div className="d-grid gap-2 px-0">
                                                <button type="submit" className="btn btn-primary mx-0" disabled={isBtn}>
                                                    {isBtn ? <Loading /> : 'Change Password '}
                                                </button>
                                            </div>
                                        </div >


                                    </div>


                                </form>
                            }
                        </>
                    </div>
                </div>
            </div>


            {/* Footer Links Section */}
                  <div className="login-footer-links w-100 text-center position-absolute" style={{ bottom: '1in' }}>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <Link to="https://blessedbuilderssoberliving.org/about-us" className="footer-link" target="_blank">About Us</Link>
                      <span className="footer-separator">|</span>
                      <Link to="https://blessedbuilderssoberliving.org/contact-us" className="footer-link" target="_blank">Contact Us</Link>
                      <span className="footer-separator">|</span>
                     {/*  <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
                      <span className="footer-separator">|</span> */}
                      <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
                    </div>
                  </div>
            
                  
        </div>
    );
};

export default ForgotPassword;